import { addUUID, removeUUID } from "../constants/userConstant";

export const AddUUID = (details) => {
  return {
    type: addUUID,
    payload: {
      uuid: details,
    },
  };
};
export const RemoveUUID = () => {
  return {
    type: removeUUID,
  };
};
